// import { Drawer, Button } from "antd";
// import { useTranslation } from "react-i18next";
// import { useSelector } from "react-redux";

// export default function ReceivedDrawer({
//   data,
//   onMoneyClose,
//   isMoneyVisible,
//   dir,
//   handleReceivedConfirmation,
// }) {
//   const { t } = useTranslation();

//   return (
//     <Drawer
//       title={t("nav.received")}
//       style={{ textAlign: dir === "rtl" ? "end" : "start" }}
//       placement="right"
//       width={
//         window.innerWidth >= 992
//           ? "50%"
//           : window.innerWidth >= 768
//           ? "75%"
//           : "100%"
//       }
//       onClose={onMoneyClose}
//       open={isMoneyVisible}
//       className="offers-drawer"
//     >
//       {data?.length > 0 ? (
//         <div className="orders pb-4 pt-4 d-flex flex-column gap-3">
//           {data.map((item) => (
//             <div
//               key={item.id}
//               className="orders__order p-2 p-md-3 p-lg-4"
//               dir={dir}
//               style={{ backgroundColor: "#C7E7D3" }}
//             >
//               <h3 className="orders__paragraph text-truncate text-center fw-semibold mb-3 fsize-5">
//                 {item?.typeName}
//               </h3>

//               <div className="orders__description d-flex justify-content-between align-items-center gap-2 mb-3">
//                 <div className="d-flex flex-column gap-1">
//                   <div className="d-flex align-items-center gap-1">
//                     <span className="orders__title fsize-9 fw-semibold">
//                       {t("buyers.weight")}
//                     </span>
//                     <span className="fsize-9 orders__qty">
//                       {item.quantitySold} {t("home.exchangeModal.kg")}
//                     </span>
//                   </div>
//                   <div className="d-flex align-items-center gap-1">
//                     <span className="orders__title fsize-9 fw-semibold">
//                       {t("buyers.pricePerKilo")}:
//                     </span>
//                     <span className="fsize-9 orders__qty">
//                       {item.pricePerKilo} {t("home.exchangeModal.le")}
//                     </span>
//                   </div>
//                   <div className="d-flex align-items-center gap-1">
//                     <span className="orders__title fsize-9 fw-semibold">
//                       {t("buyers.afterCommission")}:
//                     </span>
//                     <span className="fsize-9 orders__qty">
//                       {item.totalPriceAfterCommision}{" "}
//                       {t("home.exchangeModal.le")}
//                     </span>
//                   </div>
//                 </div>

//                 <div className="d-flex flex-column gap-1 text-end">
//                   <span className="orders__title fsize-9 fw-semibold">
//                     {t("buyers.totalPrice")}:
//                   </span>
//                   <span className="fsize-9 orders__price fw-semibold">
//                     {item.totalPrice} {t("home.exchangeModal.le")}
//                   </span>
//                 </div>
//               </div>

//               <div className="row m-0 align-items-center">
//                 <div className="col-6">
//                   <Button
//                     onClick={() => handleReceivedConfirmation(item.id, true)}
//                     className="text-center w-100 py-2 h-auto border-0 orders__order__offer-btn orders__order__offer-btn--accept"
//                   >
//                     {t("notificationModal.accept")}
//                   </Button>
//                 </div>
//                 <div className="col-6">
//                   <Button
//                     onClick={() => handleReceivedConfirmation(item.id, false)}
//                     className="text-center w-100 py-2 h-auto border-0 orders__order__offer-btn orders__order__offer-btn--reject"
//                   >
//                     {t("notificationModal.reject")}
//                   </Button>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       ) : (
//         <h2 className="white-text text-center pt-5 pe-4">
//           {t("received.noData")}
//         </h2>
//       )}
//     </Drawer>
//   );
// }

import { Drawer, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import ReceivedModal from "./ReceivedModal";

export default function ReceivedDrawer({
  data,
  onMoneyClose,
  isMoneyVisible,
  dir,
  handleReceivedConfirmation,
}) {
  const { t } = useTranslation();
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isAccepted, setIsAccepted] = useState(null);

  const openModal = (id, accepted) => {
    setSelectedId(id);
    setIsAccepted(accepted);
    setModalVisible(true);
  };

  const handleConfirm = () => {
    handleReceivedConfirmation(selectedId, isAccepted);
    setModalVisible(false);
  };

  return (
    <>
      <Drawer
        title={t("nav.received")}
        style={{ textAlign: dir === "rtl" ? "end" : "start" }}
        placement="right"
        width={
          window.innerWidth >= 992
            ? "50%"
            : window.innerWidth >= 768
            ? "75%"
            : "100%"
        }
        onClose={onMoneyClose}
        open={isMoneyVisible}
        className="offers-drawer"
      >
        {data?.length > 0 ? (
          <div className="orders pb-4 pt-4 d-flex flex-column gap-3">
            {data.map((item) => (
              <div
                key={item.id}
                className="orders__order p-2 p-md-3 p-lg-4"
                dir={dir}
                style={{ backgroundColor: "#C7E7D3" }}
              >
                <h3 className="orders__paragraph text-truncate text-center fw-semibold mb-3 fsize-5">
                  {item?.typeName}
                </h3>

                <div className="orders__description d-flex justify-content-between align-items-center gap-2 mb-3">
                  <div className="d-flex flex-column gap-1">
                    <div className="d-flex align-items-center gap-1">
                      <span className="orders__title fsize-9 fw-semibold">
                        {t("buyers.weight")}
                      </span>
                      <span className="fsize-9 orders__qty">
                        {item.quantitySold} {t("home.exchangeModal.kg")}
                      </span>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                      <span className="orders__title fsize-9 fw-semibold">
                        {t("buyers.pricePerKilo")}:
                      </span>
                      <span className="fsize-9 orders__qty">
                        {item.pricePerKilo} {t("home.exchangeModal.le")}
                      </span>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                      <span className="orders__title fsize-9 fw-semibold">
                        {t("buyers.afterCommission")}:
                      </span>
                      <span className="fsize-9 orders__qty">
                        {item.totalPriceAfterCommision}{" "}
                        {t("home.exchangeModal.le")}
                      </span>
                    </div>
                  </div>

                  <div className="d-flex flex-column gap-1 text-end">
                    <span className="orders__title fsize-9 fw-semibold">
                      {t("buyers.totalPrice")}:
                    </span>
                    <span className="fsize-9 orders__price fw-semibold">
                      {item.totalPrice} {t("home.exchangeModal.le")}
                    </span>
                  </div>
                </div>

                <div className="row m-0 align-items-center">
                  <div className="col-6">
                    <Button
                      onClick={() => openModal(item.id, true)}
                      className="text-center w-100 py-2 h-auto border-0 orders__order__offer-btn orders__order__offer-btn--accept"
                    >
                      {t("notificationModal.accept")}
                    </Button>
                  </div>
                  <div className="col-6">
                    <Button
                      onClick={() => openModal(item.id, false)}
                      className="text-center w-100 py-2 h-auto border-0 orders__order__offer-btn orders__order__offer-btn--reject"
                    >
                      {t("notificationModal.reject")}
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <h2 className="white-text text-center pt-5 pe-4">
            {t("received.noData")}
          </h2>
        )}
      </Drawer>

      {/* Custom Modal */}
      <ReceivedModal
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        onConfirm={handleConfirm}
        isAccepted={isAccepted}
      />
    </>
  );
}
